export default __webpack_public_path__ + "static/media/bryst_hel_uden_ben_overside.8bb34480.jpg";